<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <p v-if="loading">{{ $t('answerEvaluation.loading') }}</p>
        <template v-else>
          <ScaleComponent
            v-for="(scale, idx) in scales"
            :ref="`scale-${scale.scale_id}`"
            :rawData="scale"
          />
        </template>
      </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" class="d-flex justify-center">
            <v-btn color="primary" @click="onSubmit">{{ $t('answerEvaluation.submit') }}</v-btn>
        </v-col>
    </v-row>
  </v-container>
</template>
  
<script>
  import apiService from '@/services/ApiService'
  import ScaleComponent from '@/components/common/ScaleComponent.vue';

  export default {
    components: {
        ScaleComponent,
    },

    data() {
      return {
        scales: {},
        token: '',
        loading: true,
        error: ''
      };
    },
    
    name: 'AnswerEvaluationView',

    async mounted() {
      // You can perform any asynchronous operations here if needed      

      this.token = this.$route.params.token
      console.log('AnswerEvaluationView > mounted > Evaluation token:', this.token)

      await this.loadQuestions()
    },

    methods:{
      async loadQuestions(){
        try{        
          let response = await apiService.getItems(this.token)
          console.log('Response:', response);
          this.scales = response.data;

          console.log('Raw Data:', this.scales);
        } catch (error) {
          console.error('Error fetching questionnaire data:', error);
        } finally {
          this.loading = false;
        }
      },

      // async onQuestionnaireSubmited(responses){
      //   console.log('QuestionnaireView > onQuestionnaireSubmited > Responses:', responses);
      //   try{
      //     let fingerprint = localStorage.getItem(`bound_${this.token}`);          
      //     let response = await apiService.submitResponses(this.token, fingerprint, responses);    
      //     console.log('QuestionnaireView > onQuestionnaireSubmited > back end response:', response);

      //     //TODO: Check for error 
          
      //     this.$router.push({ 
      //         path: `/evaluation/thankYou`, 
      //     })
      //   }catch(error){
      //     console.error(`Error: ${error.message}`)
      //     this.error = "Could not get the fingerprint from server"
      //     this.$toast.error(this.error)
      //   }
      // },

      /** 
       * Collect all data from all scales
       * */
      collect(){
        let allScalesData = {}
        this.scales.forEach( (scale, idx) => {
          const scaleRefId = `scale-${scale.scale_id}`
          const scaleRef = this.$refs[scaleRefId][0];
          if(scaleRef){
            allScalesData[scaleRefId] = scaleRef.collect()
          }
        });
        return allScalesData;
      },

      validate(){
        let valid = true;
        this.scales.forEach( (scale, idx) => {
          console.log(`AnswerEvaluationView > validate >  scale = ${scale.scale_id}`);
          const scaleRefId = `scale-${scale.scale_id}`
          const scaleRef = this.$refs[scaleRefId][0];
          if(scaleRef){
            let scaleValid = scaleRef.validate()
            console.log(`AnswerEvaluationView > validate >  scale = ${scale.scale_id} valid = ${scaleValid}`);
            valid &&= scaleValid;
          }
        });
        return valid;
      },

      async onSubmit(){
        console.log('AnswerEvaluationView > onSubmit ');

        let valid = this.validate();
        console.log(`Evaluation is valid: ${valid}`)

        if(!valid){
          this.$toast.error(this.$t('answerEvaluation.evaluation_is_not_complete'))
          return false;
        }

        let answers = this.collect();
        console.log('AnswerEvaluationView > onSubmit > allData > ', answers);

        try{
          let fingerprint = localStorage.getItem(`bound_${this.token}`);          
          const evaluation_link_fragment = `${process.env.VUE_APP_PROTOCOL}://${process.env.VUE_APP_HOST}:${process.env.VUE_APP_PORT}/psychologist/viewEvaluation`;
          let response = await apiService.submitResponses(this.token, fingerprint, answers, evaluation_link_fragment);    
          console.log('AnswerEvaluationView > onSubmit > back end response:', response);
          
          this.$router.push({ 
              path: `/evaluation/thankYou`, 
          })
        }catch(error){
          console.error(`Error: ${error.message}`)
          this.error = this.$t('answerEvaluation.could_not_get_the_fingerprint_from_server')
          this.$toast.error(this.error)
        }
      }
    }
  }
</script>
  
<style scoped>
</style>